/**
 * A collection's search and filters are part of its address (`useListState`),
 * so the routes that hold one declare it: string params, empties dropped, and
 * nothing else kept. Which params a list has is the list's business — this says
 * only what SHAPE they take, which is the same for every one of them.
 *
 * **A value the router read as a number or a flag is kept as its text.** The
 * router reads `?offers=1` as the number one, because it parses a value as JSON
 * where it can, and an address written by the router quotes a string that
 * would otherwise read that way. An address written anywhere else does not — a
 * link in a mail, one typed by hand — so a bare `1` arrives as a number, and
 * dropped for not being a string it opens the page without the thing it asked
 * for. The text kept is the router's reading rather than what was typed, so
 * `1e3` comes back as `1000` and `12.50` as `12.5`.
 */
export const listSearch = (
  raw: Record<string, unknown>,
): Record<string, string> => {
  const out: Record<string, string> = {}
  for (const [key, value] of Object.entries(raw)) {
    const said =
      typeof value === 'number' || typeof value === 'boolean'
        ? String(value)
        : value
    if (typeof said === 'string' && said !== '') out[key] = said
  }
  return out
}
